import { Button } from '@billy/design-system'
import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { Scope } from '../../../../../../../../../../enums/scope'
import { isAuthorized } from '../../../../../../../../../../utils/isAuthorized'
import { useAttachmentPreviewModal } from '../../../../../../context/attachmentPreviewModalContext'

interface ManageUploadButtonProps {
  isEDocument: boolean
  blocked?: boolean
}

export const ManageUploadButton = ({ isEDocument, blocked }: ManageUploadButtonProps): ReactElement => {
  const { t } = useTranslation()
  const { handleManageUploadButtonClick } = useAttachmentPreviewModal()

  const isEnabled = isAuthorized(Scope.BillWrite)

  const resolvedButtonLabel = (() => {
    if (blocked) {
      return t('receipt.list.blocked')
    }

    if (isEDocument) {
      return t('receipt.manage_e_invoice')
    }

    return t('attachment_preview_modal.footer.select_attachment')
  })()

  return (
    <Button disabled={!isEnabled} fullWidth onClick={handleManageUploadButtonClick} size="md">
      {resolvedButtonLabel}
    </Button>
  )
}
